import { Component, useEffect } from "react";
import { useLocation } from "react-router-dom";

class Boundary extends Component {
  state = { error: null };
  static getDerivedStateFromError(error) { return { error }; }
  componentDidCatch(error) {
    const key = "tml_recovered";
    if (!sessionStorage.getItem(key)) {
      sessionStorage.setItem(key, "1");
      window.location.reload();
    }
    console.error(error);
  }
  render() {
    if (this.state.error)
      return (
        <div className="min-h-[70vh] flex flex-col items-center justify-center text-center px-6 pt-32" data-testid="page-error">
          <p className="h2">Something went wrong loading this page.</p>
          <button onClick={() => window.location.reload()} className="btn-gold mt-8" data-testid="page-error-reload-btn">Reload page</button>
        </div>
      );
    return this.props.children;
  }
}

export default function PageBoundary({ children }) {
  const { pathname } = useLocation();
  useEffect(() => {
    const t = setTimeout(() => sessionStorage.removeItem("tml_recovered"), 5000);
    return () => clearTimeout(t);
  }, [pathname]);
  return <Boundary key={pathname}>{children}</Boundary>;
}
